import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=33a55eaa&"
import script from "./Consulta.vue?vue&type=script&lang=js&"
export * from "./Consulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports